var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"events-calendar__export-button"},[_c('button',{staticClass:"button button-primary",on:{"click":function($event){$event.preventDefault();return _vm.exportEvents.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('Export events'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }